export const myPresentationText ={
    esp: 'Soy Juan Drouville.\n Diseñador y programador enfocado en crear y resolver.',
    por: 'Oi, sou Juan Drouville. \n Designer e desenvolvedor focado em criar e resolver.',
}